import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class OutletService {

  constructor(private ws: PostmethodService) { }

  getOutlet() {
    return this.ws.wsGet(environment.baseUrl + "masters/outlet");
  }

  createOutlet(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/outlet");
  }

  updateOutlet(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/outlet", id);
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZone() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getState() {
    return this.ws.wsGet(environment.baseUrl + "masters/state");
  }

  getDealerList() {
    return this.ws.wsGet(environment.baseUrl + "masters/dealer");
  }

  productCategoryList(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productCategoryMaster");
  }

  getDistrictByRegion(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-districts-by-region", id);
  }

  getAreaByDistrict(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-areas-by-district", id);
  }

  getExport() {
    return this.ws.wsGet(environment.baseUrl + "reports/userExportOutletReport");
  }

  getUserList(id: any, type: string) {
    return this.ws.wsGet(
      `${environment.baseUrl}masters/outlet/outletUser/${id}?type=${type}`
    );
  }
}
